import { Box, Typography } from '@mui/material';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaidIcon from '@mui/icons-material/Paid';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

// Etapas do status em linha (status + data/hora) sobre o gradiente do cabeçalho
// (Ordem de Serviço e Orçamento). Em larguras menores a linha rola na horizontal.
// Cada etapa: { title, sub?, state: 'done' | 'off' }; o ícone vem do título.
const STEP_ICONS = {
    // Ordem de Serviço
    'OS criada': NoteAddIcon,
    'Iniciada': PlayArrowIcon,
    'Finalização': CheckCircleIcon,
    'Faturada': PaidIcon,
    'OS cancelada': CancelIcon,
    // Orçamento
    'Orçamento criado': NoteAddIcon,
    'Enviado': SendIcon,
    'Aprovado': CheckCircleIcon,
    'Ordem gerada': SwapHorizIcon,
};

export default function HeaderStatusSteps({ steps }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', overflowX: 'auto', pb: 0.5 }}>
            {steps.map((step, index) => {
                const done = step.state === 'done';
                const last = index === steps.length - 1;
                return (
                    <Box key={`${step.title}-${index}`} sx={{ display: 'flex', alignItems: 'flex-start', flex: last ? '0 0 auto' : '1 0 auto', minWidth: 130 }}>
                        <Box sx={{ flex: '0 0 auto', maxWidth: 220 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {(() => {
                                    const StepIcon = STEP_ICONS[step.title] || CheckCircleIcon;
                                    return <StepIcon sx={{ fontSize: 20, color: done ? '#fff' : 'rgba(255,255,255,.4)' }} />;
                                })()}
                                <Typography component="span" sx={{ fontSize: 13, fontWeight: 700, color: done ? '#fff' : 'rgba(255,255,255,.7)', whiteSpace: 'nowrap' }}>
                                    {step.title}
                                </Typography>
                            </Box>
                            {step.sub && (
                                <Typography component="div" sx={{ fontSize: 12, color: 'rgba(255,255,255,.75)', mt: 0.25, pl: '28px' }}>
                                    {step.sub}
                                </Typography>
                            )}
                        </Box>
                        {!last && <Box sx={{ flex: '1 1 24px', minWidth: 24, height: 2, mt: '9px', mx: 1.5, bgcolor: 'rgba(255,255,255,.3)' }} />}
                    </Box>
                );
            })}
        </Box>
    );
}
